// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"9b1e6972","174":"e46eb652","453":"9318896a","541":"d1a21c02","597":"9577620d","614":"704cd7d3","677":"cd331f5e","779":"f2e273cc","802":"ab1fd502","865":"7a92317f","892":"9dfaf10a","937":"3242470b","971":"55eb9a30"}[chunkId] + ".chunk.js";
};